import React from 'react';
import Chart from "react-apexcharts";


const RedialChart = ({ data }) => {
    // const value = data.value * data.
    var options = {
        series: [data.value],
        options: {
            chart: {
                type: 'radialBar',
                offsetY: -20,
                sparkline: {
                    enabled: true
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -90,
                    endAngle: 90,
                    track: {
                        background: "#e7e7e7",
                        strokeWidth: '90%',
                        margin: 5, // margin is in pixels
                        dropShadow: {
                            enabled: true,
                            top: 2,
                            left: 0,
                            color: '#999',
                            opacity: 1,
                            blur: 2
                        }
                    },
                    dataLabels: {
                        name: {
                            show: false
                        },
                        value: {
                            offsetY: -2,
                            fontSize: '22px',
                            formatter: function (val) {
                                return val.toFixed(2)
                                // return parseInt(val);
                            },
                        }
                    },
                },
            },
            grid: {
                padding: {
                    top: -10
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'as',
                    shadeIntensity: 0.4,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 25, 50, 53, 91]
                },
            },
            labels: ['Average Results'],
        },


    };

    return (
        <div>
            <h4 className="text-center fw-bold mb-0"> {data.title} </h4>
            <Chart
                options={options.options}
                series={options.series}
                type="radialBar"
            />
        </div>
    );
};

export default RedialChart;